import React from 'react';
import PropTypes from 'prop-types';
import ImageZoomer from './imageZoomer';

const { imageBasePath, staticImageBasePath, client } = window.inlineGlobalConfig;

export const getStaticMediaSrc = src => src.replace(`${imageBasePath}i/${client}`, staticImageBasePath);

function mediaItem({ item, isZoomable, isFullSize, sizes }) {
  let media;
  if (item.type === 'video') {
    const videoUrl = new URL(item.src);
    media = (
      <video className="video" poster={item.src} preload="metadata" autoPlay playsInline loop muted>
        <source src={`${videoUrl.origin}${videoUrl.pathname}/mp4_720p${videoUrl.search}`} type="video/mp4" />
      </video>
    );
  } else if (item.type === 'img' && item.format === 'GIF') {
    media = <img src={getStaticMediaSrc(item.src)} alt={item?.altText || ''} />;
  } else {
    media = (
      <ImageZoomer
        src={item.src}
        alt={item?.altText || ''}
        isInteractive={isZoomable}
        isFullSize={isFullSize}
        sizes={sizes}
      />
    );
  }

  return <div className="media-item">{media}</div>;
}

mediaItem.defaultProps = {
  isZoomable: true,
  isFullSize: false,
  sizes: { s: '90vw', l: '40vw' },
};

mediaItem.propTypes = {
  item: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])).isRequired,
  isZoomable: PropTypes.bool,
  isFullSize: PropTypes.bool,
  sizes: PropTypes.objectOf(PropTypes.string),
};

export default mediaItem;
